import { download, generateCsv, mkConfig } from "export-to-csv"
import { DateTime } from "luxon"
import { useCallback } from "react"
import { useDateTime } from "../../../../localization/useDateTime"
import { useAppLocalization } from "../../../../localization/components/AppLocalizationProvider"
import { GuestReportEntry } from "../statisticsTypes"

type useExportGuestsToCsvParams = Readonly<{
    data: GuestReportEntry[] | null | undefined
    startDate: DateTime
    endDate: DateTime
}>

export function useExportGuests({ data, startDate, endDate }: useExportGuestsToCsvParams) {
    const dateTimeFactory = useDateTime()
    const { l10n } = useAppLocalization()

    const csvOptions = mkConfig({
        fieldSeparator: ";",
        quoteStrings: true,
        decimalSeparator: ".",
        useBom: true,
        useKeysAsHeaders: true,
        filename: `Facilitynet-guests-${dateTimeFactory.formatDate(startDate)}_${dateTimeFactory.formatDate(endDate)}`,
    })

    const mapEntryToCsvRow = (entry: GuestReportEntry) => {
        return {
            From: dateTimeFactory.formatDate(startDate),
            To: dateTimeFactory.formatDate(endDate),
            Date: entry.date,
            "Guests Amount": entry.number,
        }
    }

    return useCallback(() => {
        let exportRows: ReturnType<typeof mapEntryToCsvRow>[]

        if (data && data.length > 0) {
            exportRows = data.map((entry) => mapEntryToCsvRow(entry))
        } else {
            exportRows = [mapEntryToCsvRow({} as GuestReportEntry)]
        }

        const csv = generateCsv(csvOptions)(exportRows)
        download(csvOptions)(csv)
    }, [dateTimeFactory, data, startDate, endDate, l10n])
}
